export const REGISTER = "REGISTER";
export const LOGIN = "LOGIN";
export const LOGIN_ID = "LOGIN_ID";
export const LOGOUT = "LOGOUT";